import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "evc_access_token";
export const ADMIN_TOKEN_KEY = "evc_admin_token";
export const MO_TOKEN_KEY = "evc_mo_token";
export const WHATSAPP_NUMBER = "4915122947600";
export const WHATSAPP_LINK =
  "https://wa.me/" +
  WHATSAPP_NUMBER +
  "?text=" +
  encodeURIComponent(
    "Hello EVC team, I'd like to talk about the ITFM maturity assessment and how you can help."
  );

export const LINKEDIN_LINK = "https://www.linkedin.com/in/marchesse/";

// TODO: replace with the real booking/contact URL once provided.
export const CONTACT_LINK = "#";
